import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const OutboundMoveAssetRoute: Route = {
  path: 'outbound/move-asset',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/move-asset.component').then((m) => m.OutboundMoveAssetComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
